@if (vm$ | async; as vm) {
  <div class="item-media-preview">
    <div class="content-view">
      @if (vm?.attachments?.length) {
        <div class="actions">
          <div class="download-file action-item" (click)="downloadFile(vm?.preview)"><i class="fa fa-download"></i> Download</div>
        </div>
      }
      <div class="box-review">

        @switch (vm?.preview?.type) {

          @case ('Form') {
            <div class="holds-the-iframe">
              <iframe [src]="prepareLinkPreviewForm(filePath) | safeUrl" width='100%' height='100%' frameborder='0'></iframe>
            </div>
          }

          @default {
            @let previewOption = $previewOption();

            @if (imgPath) {
              <img [src]="imgPath | resizeImage:'w-1080'" />
            }

            @if (filePath && !previewOption) {
              <div class="holds-the-iframe">
                <iframe [src]="prepareLinkPreview(filePath) | safeUrl" width='100%' height='100%' frameborder='0'></iframe>
              </div>
            }

            @if (previewOption) {
              @if (previewOption.fileExtension === 'pdf') {
                <div class="holds-the-iframe">
                  <ng2-pdfjs-viewer [pdfSrc]="previewOption.path | pdfBlob | async" [urlValidation]="false" [downloadFileName]="vm?.preview?.title" viewerId="pdf-viewer"></ng2-pdfjs-viewer>
                </div>
              }

              @if (previewOption.fileExtension === 'csv') {
                @if (previewOption.isLoading) {
                  <span>Loading...</span>
                } @else {
                  <ngx-monaco-editor [options]="previewOption" />
                }
              }
            }
          }

        }

      </div>
    </div>

    <div class="right-bar">

      <div class="header-preview">
        <div class="header-content">Attachments</div>
      </div>

      <div class="data-preview-container">
        <div class="upload-area">
          <attachment-field [readonly]="vm?.readonly" [isEditMode]="!vm?.readonly" (uploadAllDone)="onChangeAttachments($event)" [isCustomUI]="true" [mode]="mode" [type]="type"></attachment-field>
        </div>
        <div class="data-preview">
          @for (attachment of vm?.attachments; track attachment._id) {
            <file-view [editMode]="!vm?.readonly" [showDownloadBtn]="false" [active]="vm?.preview?._id === attachment._id" [file]="attachment" [allowedExtensionFile]="allowedExtensionFile" [allowedExtensionIMG]="allowedExtensionIMG" (download)="downloadFile($event)" (preview)="preview($event)" (delete)="deleteFile($event)"></file-view>
          }
        </div>
      </div>

      <div class="footer">
        <w-button displayStyle="Tertiary" size="Medium" label="Close" (onClick)="closePreview()" />
      </div>

    </div>

  </div>
}
